import React from 'react';

import {
  BooleanCell,
  NameCell,
  RatingCell,
  SortCell,
} from '../../../../../shared/components/DataTable';

const caseColumn = {
  accessorKey: 'reviewRequest.clientTask.task.name',
  header: ({ column }) => <SortCell column={column} label="Case" />,
};

const clientColumn = {
  accessorKey: 'reviewRequest.clientTask.client.fullName',
  cell: ({ row }) => <NameCell person={row.original.reviewRequest.clientTask.client} />,
  header: ({ column }) => <SortCell column={column} label="Client" />,
};

const ratingColumn = {
  accessorKey: 'rating',
  cell: RatingCell,
  header: ({ column }) => <SortCell column={column} label="Rating" />,
};

const contentColumn = {
  accessorKey: 'content',
  header: 'Content',
};

const featuredColumn = {
  accessorKey: 'isFeatured',
  cell: BooleanCell,
  header: 'Featured',
};

const columns = [caseColumn, clientColumn, ratingColumn, contentColumn, featuredColumn];

export default columns;
